import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import InventoryAdjustmentRecordView from "./inventory-adjustment-record";
import InventoryAdjustmentReportView from "./inventory-adjustment-report";
import InventoryAdjustmentListView from "./inventory-adjustment-list";
import InventoryAdjustmentSingleView from "./single";
import BulkAdjustInventoryView from "./bulk-adjust-inventory";
import useAccessLevels from "../../../../../hooks/use-access-levels";

const InventoryAdjustmentViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();


    /**
     * Listens for the changes in the url and which each change:
     * if the url is the same as /product/inventory-adjustment, changes it immediately to the /products/inventory-adjustment/list
     */
    useEffect(() => {
        if (!!matchPath(location.pathname, {path: routes.inventory.inventoryAdjustment.base, exact: true})) {
            if (operatorAccessLevels.packages.bizInventory.adjustmentList) {
                history.replace(routes.inventory.inventoryAdjustment.list);
            } else if (operatorAccessLevels.packages.bizInventory.adjustmentItems) {
                history.replace(routes.inventory.inventoryAdjustment.items);
            } else if (operatorAccessLevels.packages.bizInventory.adjustmentReports) {
                history.replace(routes.inventory.inventoryAdjustment.report);
            } else {
                history.replace(routes.inventory.inventoryAdjustment.base.concat(routes.error.accessDeniedForSection));
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.bizInventory.adjustmentItems, operatorAccessLevels.packages.bizInventory.adjustmentList, operatorAccessLevels.packages.bizInventory.adjustmentReports, operatorAccessLevels.packages.bizInventory.bulkAdjustments]);

    return (
        <Switch>
            <Route path={routes.inventory.inventoryAdjustment.base} exact/>
            {
                operatorAccessLevels.packages.bizInventory.adjustmentList &&
                <Route path={routes.inventory.inventoryAdjustment.list} exact>
                    <InventoryAdjustmentListView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.bizInventory.bulkAdjustments &&
                <Route path={routes.inventory.inventoryAdjustment.bulkAvailabilityChange} exact>
                    <BulkAdjustInventoryView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.bizInventory.adjustmentItems &&
                <Route path={routes.inventory.inventoryAdjustment.items} exact>
                    <InventoryAdjustmentRecordView product={null} loading={false}/>
                </Route>
            }
            {
                operatorAccessLevels.packages.bizInventory.adjustmentReports &&
                <Route path={routes.inventory.inventoryAdjustment.report} exact>
                    <InventoryAdjustmentReportView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.bizInventory.adjustmentInformation &&
                <Route path={routes.inventory.inventoryAdjustment.single} exact>
                    <InventoryAdjustmentSingleView/>
                </Route>
            }
            <Redirect to={routes.inventory.inventoryAdjustment.base.concat(routes.error.accessDeniedForSection)}/>
        </Switch>
    );
}

export default InventoryAdjustmentViews;
